// @flow

import React from "react";
import { ButtonsGroup, Text } from "buba-components";
import { withRouter } from "react-router";
import sharedStyles from "../shared.scss";
import { setStatusSubmitInterest, setStatusDeclineByBank } from "../../../../api/actions";
import SetStatusModalLauncher from "../SetStatusModalLauncher";
import paths from "../../../../data/paths";

type ActionsForNewProps = {
  id: number,
  displayErrorForStatusCode: (?number) => void,
  requestFetch: any => void,
  history: {
    push: (path: string) => void
  }
};

const ActionsForNew = ({
  id,
  displayErrorForStatusCode,
  requestFetch,
  history
}: ActionsForNewProps) => (
  <>
    <header>Bekundung Interesse</header>
    <Text additionalClasses={sharedStyles.actionText}>
      Falls Sie nach einer Vorprüfung Interesse an der Kundenanfrage haben, teilen Sie uns dies
      bitte zeitnah mit. Andernfalls wird die Anfrage an andere Banken weitergeleitet, um den
      Kundenwunsch zu bedienen.
    </Text>
    <ButtonsGroup>
      <SetStatusModalLauncher
        id={id}
        triggerButtonText="Vorprüfung erfolgreich"
        contentText="Sie sind im Begriff, Interesse an dieser Anfrage zu bekunden. Sind Sie sicher?"
        displayErrorForStatusCode={displayErrorForStatusCode}
        requestFetch={requestFetch}
        setStatusAction={setStatusSubmitInterest}
        statusName="submit interest"
      />
      <SetStatusModalLauncher
        id={id}
        triggerButtonText="Kein Interesse"
        contentText="Sie Sind im Begriff, diese Anfrage abzulehnen. Sind Sie sicher?"
        displayErrorForStatusCode={displayErrorForStatusCode}
        requestFetch={() =>
          new Promise(resolve => {
            history.push(paths.customerInquiriesList);
            resolve();
          })
        }
        setStatusAction={setStatusDeclineByBank}
        statusName="declined by ban"
      />
    </ButtonsGroup>
  </>
);

export default withRouter(ActionsForNew);
